import { paymentStatementApi } from './base';

export type AnalyticsRange = 7 | 30 | 90;

export interface AnalyticsRep {
	name: string;
	email: string;
	statements: number;
	processed: number;
	avg_monthly_savings: number | null;
	median_processing_seconds: number | null;
}

export interface AnalyticsOpportunity {
	statement_id: string;
	name: string;
	rep: string;
	monthly_volume: number;
	yearly_savings: number;
	days_open: number;
}

export interface AnalyticsReport {
	days: AnalyticsRange;
	since: string;
	totals: {
		statements: number;
		processed: number;
		median_processing_seconds: number | null;
		avg_monthly_savings: number | null;
	};
	weeks: { week_start: string; statements: number }[];
	reps: AnalyticsRep[];
	insights: {
		flagged_statements: number;
		most_common_issue: string | null;
		statements_with_savings: number;
		quoted_statements: number;
		avg_current_effective_rate: number | null;
		avg_proposed_effective_rate: number | null;
		rate_plans: Record<string, number>;
	};
	opportunities: AnalyticsOpportunity[];
}

export const analyticsApi = paymentStatementApi.injectEndpoints({
	endpoints: (builder) => ({
		getAnalytics: builder.query<AnalyticsReport, AnalyticsRange>({
			query: (days) => `/analytics?days=${days}`,
		}),
	}),
});

export const { useGetAnalyticsQuery } = analyticsApi;
